<div *ngIf="expression" class="expression">
  <mat-icon style="cursor: pointer" (click)="clearExpression()">clear</mat-icon>
  <p style="margin: 0">{{ expression }}</p>
</div>
